import styled from "styled-components"

export const IconWrapper = styled.img`
    display: flex;
    font-weight: normal;
    font-style: normal;
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
    display: inline-block;
    line-height: 1;
    text-transform: none;
    letter-spacing: normal;
    word-wrap: normal;
    white-space: nowrap;
    direction: ltr;
    background-color: rgb(1, 62, 76);
    color: rgb(255, 255, 255);
    margin-right: 16px;
    padding: 10px;
    border-radius: 30px;
    box-sizing: border-box;
`